'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.compare_graph_show', {
    url: 'compare/:ids?:type&:term&:graphType&:date&:mdate&:wdate',
    template: '<compare-graph></compare-graph>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/show/compare-graph-show.routes.js